import { render, staticRenderFns } from "./bettingLog.vue?vue&type=template&id=63d8de02&"
import script from "./bettingLog.vue?vue&type=script&lang=js&"
export * from "./bettingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports